<template>
  <b-modal
    id="ModalExcluirEmpresa"
    :no-close-on-backdrop="loadingExcluir"
    :no-close-on-esc="loadingExcluir"
  >
    <Header mini titulo="Excluir empresa" icone="times-circle" cor="vermelho" slot="modal-header" />
    <div class="modal-excluir-empresa-corpo">
      <LoadingPadraoContainer
        v-if="loadingExcluir"
        class="loading-padrao-backdrop"
        background
        :fraseLoading="['Excluindo Empresa', 'Aguarde um momento']"
        delay="5000"
        classe="azul"
      />

      <div>
        {{
          `Tem certeza que deseja remover a empresa "${
            dadosEmpresaDelete && dadosEmpresaDelete.nome ? dadosEmpresaDelete.nome : ""
          }" ?`
        }}
      </div>
      <div>
        Os produtos vinculados a esta empresa também serão removidos.
      </div>
    </div>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :click="cancelar"
        :desabilita="loadingExcluir"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Excluir"
        icone="check"
        :click="handleClick"
        :desabilita="loadingExcluir"
        cor="vermelho"
      />
    </template>
  </b-modal>
</template>

<script>
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";

import Api from "@/services/api.js";

export default {
  name: "ModalExcluirEmpresa",
  components: {
    LoadingPadraoContainer,
    BotaoPadrao,
    Header
  },
  props: {
    dadosEmpresaDelete: Object
  },
  data() {
    return {
      loadingExcluir: false
    };
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  methods: {
    async handleKey(event) {
      let modal = document.getElementById("ModalExcluirEmpresa");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          await this.handleClick();
        }
      }
    },
    async handleClick() {
      this.loadingExcluir = true;
      await new Api().get(`Empresa/excluirEmpresa/${this.dadosEmpresaDelete.id}`);
      this.loadingExcluir = false;
      this.$emit("atualizaEmpresas");
      this.$root.$emit("bv::hide::modal", "ModalExcluirEmpresa");
    },
    cancelar() {
      this.$root.$emit("bv::hide::modal", "ModalExcluirEmpresa");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-excluir-empresa-corpo {
  text-align: center;
}
</style>
